<template>
  <div class="customer-review-container">
    <v-card class="customer-review-card">
      <p class="customer-name">
        {{ review.clientName }}
      </p>

      <StarRating
        :rating="review.score"
        justify="flex-start"
        :editable="false" />

      <div class="review-content">
        {{ message }}
      </div>

      <div v-if="isTooLong">
        <button
          class="default-btn link"
          @click="expanded = !expanded">
          {{ expandText }}
        </button>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ProviderReview',
  props: {
    review: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    maxTextLength: 200,
    expanded: false,
  }),

  computed: {
    isTooLong () {
      return this.review.description.length > this.maxTextLength
    },

    message () {
      return this.isTooLong && !this.expanded
        ? this.review.description.slice(0, this.maxTextLength) + '...'
        : this.review.description
    },

    expandText () {
      return this.expanded ? 'Read less' : 'Read more'
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-review-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  padding: 36px 0;

  font-family: "Sansation Regular", Serif;

  .v-card.customer-review-card {
    background-color: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
}

.customer-name {
  margin-bottom: 15px;
  font-family: "Sansation Bold", Serif;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0;
  color: #4e4e4e;
}

.customer-review-card {
  width: 100%;
}

.review-content {
  margin-top: 25px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  color: #4e4e4e;
}

</style>
